<template>
	<Carousel id="gallery" :items-to-show="1" wrap-around v-model="currentSlide">
		<Slide v-for="slide in slides" :key="slide.id">
			<div class="carousel__item">
				<div class="product-img-carousel">
					<picture>
						<source type="image/webp" :srcset="slide.urlMin">
						<img :src="slide.url" alt="product image">
					</picture>
				</div>
			</div>
		</Slide>
	</Carousel>

	<Carousel
		id="thumbnails"
		:items-to-show="4"
		:wrap-around="true"
		v-model="currentSlide"
		ref="carousel"
	>
		<Slide v-for="slide in slides" :key="slide.id">
			<div class="carousel__item carousel__item_thumbnails" @click="slideTo(slide.id)">
				<div class="product-img-thumbnails">
					<picture>
						<source type="image/webp" :srcset="slide.urlMin">
						<img :src="slide.url" alt="product image">
					</picture>
				</div>
			</div>
		</Slide>
	</Carousel>
</template>

<script>
import { defineComponent } from 'vue'
import { Carousel, Slide } from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'
import {Popover} from "v-calendar";

export default defineComponent({
	name: 'GalleryCarousel',
	components: {
		Popover,
		Carousel,
		Slide,
	},
	data: () => ({
		currentSlide: 0,
	}),
	props: {
		slides: {
			type: Array,
			required: true,
			validator(value) { return value && value.every(v => v && v.url && v.urlMin); },
		}
	},
	methods: {
		slideTo(val) {
			this.currentSlide = val
		},
	},
})
</script>

<style lang="scss" scoped>
.carousel__item {
	padding: 0 0 20px;
	&_thumbnails {
		padding: 0 10px;
		@media(max-width: 450px) {
			padding: 0 5px;
		}
	}
	.product-img-carousel {
		overflow: hidden;
		border-radius: 13px;
		max-width: 650px;
		position: relative;
		&:after {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			box-shadow: inset 1px 2px 3px #0752A34D;
			border-radius: 13px;
		}
		img {
			object-fit: contain;
			height: 100%;
			width: 100%;
			margin-bottom: -4px;
		}
	}
	.product-img-thumbnails {
		overflow: hidden;
		border-radius: 13px;
		max-width: 250px;
		position: relative;
		@media(max-width: 520px) {
			border-radius: 7px;
		}
		&:after {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			box-shadow: inset 1px 2px 3px #0752A34D;
			border-radius: 13px;
			@media(max-width: 520px) {
				border-radius: 7px;
			}
		}
		img {
			object-fit: contain;
			height: 100%;
			width: 100%;
			margin-bottom: -4px;
		}
	}
}
</style>
